export const state = {
  trucks: [],
  truck: [],
  truckallocations: [],
  systemTruck: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucks/state.js